/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Csv_Unsupported_Encoding_DescriptionInputs */

const en_toast_csv_unsupported_encoding_description = /** @type {(inputs: Toast_Csv_Unsupported_Encoding_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save the file as CSV UTF-8 in Excel and upload it again.`)
};

const nl_toast_csv_unsupported_encoding_description = /** @type {(inputs: Toast_Csv_Unsupported_Encoding_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sla het bestand in Excel op als CSV UTF-8 en upload het opnieuw.`)
};

/**
* | output |
* | --- |
* | "Save the file as CSV UTF-8 in Excel and upload it again." |
*
* @param {Toast_Csv_Unsupported_Encoding_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_csv_unsupported_encoding_description = /** @type {((inputs?: Toast_Csv_Unsupported_Encoding_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Csv_Unsupported_Encoding_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_csv_unsupported_encoding_description(inputs)
	return en_toast_csv_unsupported_encoding_description(inputs)
});